import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom'; // Add useLocation here
import './App.css';
import Navbar from './components/navbar';
import Home from './pages/home';
import About from './pages/about';
import Retreat from './pages/retreat';
import Gallery from './pages/gallery';
import Contact from './pages/contact';
import Footer from './components/footer';
import Shop from './pages/shop';
import GalleryModal from './components/galleryModal';

// ScrollToTop Component
const ScrollToTop = () => {
  const { pathname } = useLocation(); // Hook to get the current location

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top whenever the pathname changes
  }, [pathname]);

  return null; // This component doesn't render anything
};

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className={`h-[100dvh] ${menuOpen ? 'overflow-hidden' : ''}`}>
      <Router>
        <ScrollToTop /> {/* Place ScrollToTop here */}
        <div>
          <GalleryModal />
          <Navbar menuOpen={menuOpen} toggleMenu={toggleMenu} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/shopping" element={<Shop />} />
            <Route path="/retreats" element={<Retreat />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </div>
  );
}

export default App;
